/* istanbul ignore file */
import { connect } from 'react-redux';

import MobileSizeSelector from 'components/CustomCollectionProductCard/MobileSizeSelector';
import Product from 'models/Product';
import * as actions from 'state/actions';
import { ADD_TO_CART_ANALYTICS_ORIGINS } from 'state/constants';
import { getMasterProductData, getProductData } from 'state/selectors/collection';

const mapStateToProps = (state, ownProps) => {
  const { productHandle, isMasterProduct } = ownProps;

  let sortedSizes;
  let type;

  if (isMasterProduct) {
    const masterHandle = productHandle;

    const masterProduct = getMasterProductData(state, masterHandle);

    if (!masterProduct) {
      throw new Error(`Could not find master product with handle "${masterHandle}"`);
    }

    const currentColorway = new Product(getProductData(state, masterProduct.currentProduct));
    sortedSizes = currentColorway.sortedSizes;
    type = currentColorway.type;
  } else {
    const productData = getProductData(state, productHandle);
    const product = new Product(productData);
    sortedSizes = product.sortedSizes;
    type = product.type;
  }

  return {
    ...ownProps,
    sortedSizes,
    type,
  };
};

const mapDispatchToProps = dispatch => ({
  onSizeSelection: (variantId, targetSelector) => {
    dispatch(
      actions.addLineItems(
        { [variantId]: 1 },
        { targetSelector, origination: ADD_TO_CART_ANALYTICS_ORIGINS.QUICK_ADD }
      )
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileSizeSelector);
